module.exports = __webpack_public_path__ + "img/0a05197.jpg";